<template>


	<div class="first-level-nav">

    <span
      :id="navItem"
      v-for="navItem in navItems"
      :class="[{'is-active': navItem == activeItem}, {'is-disabled': isDisabled(navItem)}]"
      @click="setActive(navItem)">
        <lang :labelKey="`SITE-TOP-NAV-${navItem}`"></lang>
    </span>

    <div class="bottom-line"></div>

	</div>
</template>


<script>
export default {
	name: 'firstLevelNav',

	data() {
		return {
      navItems: ['GENERAL', 'APOKAT', 'APOPOINT'],
      activeItem: null,
    }
  },

  props: {
    mainTab: {
      type: String,
      default: 'GENERAL'
    },
    site: {
      type: Object,
      default: () => {}
    }
  },

  created() {
    this.activeItem = this.mainTab;
  },

  mounted() {

  },

  methods: {

    setActive(item) {
      this.activeItem = item;
      this.$emit('setActiveTab', item);
    },
    isDisabled(navItem) {

      // disable the menu item if navItem is "apopoint" and it has _not_ hasApopoint set to true OR the site does not have a parent
      return navItem == 'APOPOINT' && this.site.site.hasApoPoint == false && !this.site.site.parent;
    }

  }
}

</script>


<style lang="scss" scoped>

	.first-level-nav {
    display: flex;
    position: relative;
		padding: 0;
		/*background-color: #F5F5F5;
		border-radius: 3px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    */
		/*gap: 24px;*/
    /*border-bottom: 1px solid #F0F0F0;*/


		> span {
      z-index: 12;
			font-size: 14px;
			display: block;
			padding: 16px 20px 16px;
			cursor: pointer;
			background-color: #FFF;


      /*border-bottom: 4px solid transparent;*/
			transition: all .2s ease;

      &:first-child {
        border-top-left-radius: 3px;
        border-bottom-left-radius: 3px;
      }
      &:last-of-type {
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
      }

			&:hover {
        background-color: #475465bd;
        /*border-bottom: 4px solid #475465;*/
        color: white;
			}
			&.is-active {
        /*background-color: #475465bd;*/
        /*border-bottom: 4px solid #475465;*/
        background-color: #475465;
        color: white;
			}

      &.is-disabled {
        background-color: #F5F5F5;
        color: #AAA;
      }

		}

    .bottom-line {
      display: none;
      position: absolute;
      bottom: 0;
      z-index: 1;
      width: 100%;
      height: 4px;
      background-color: #DDD;
    }

	}


</style>
